import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Spin, Tabs, message } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import useStore from '../../store/useStore';
import { exportToXLSX } from '../../utils/xlsxHelper';
import { getDateTime } from '.././../utils/format';
import './Product.less';
import ProductDetailInfo from './ProductDetailInfo';
import ProductPrice from './ProductPrice';
import ProductSale from './ProductSale';
import Index from './ProductStock';

const TABS = [
  { key: 'general', label: 'Барааны дэлгэрэнгүй' },
  { key: 'stock', label: 'Агуулахын үлдэгдэл' },
  { key: 'priceHistory', label: 'Үнийн түүх' },
  { key: 'sale', label: 'Хямдрал' },
];

const eventCodeDict = {
  procurement: 'Татан авалт',
  delivery: 'Хүргэлт',
  return: 'Буцаалт',
  created: 'Хүргэлт',
  delivered: 'Хүргэлт',
  cancel: 'Цуцлагдсан',
  count: 'Тооллого',
};

const ProductListWithDetail = () => {
  const { productId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const isB2B = useStore((state) => state?.user?.isB2B);
  const [isErlian, setIsErlian] = useState(false);
  const [detail, setDetail] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);
  const [toggling, setToggling] = useState(false);
  const [exporting, setExporting] = useState(false);

  const initialTab = new URLSearchParams(location.search).get('tab') || TABS[0].key;
  const getValidKey = (key) => (TABS.find((tab) => tab.key === key) ? key : TABS[0].key);

  const [currentTab, setCurrentTab] = useState(() => getValidKey(initialTab));

  useEffect(() => {
    if (productId) {
      getProductDetail(productId);
    }
  }, [productId]);

  const getProductDetail = (id) => {
    setDetailLoading(true);
    axios
      .get(`/api/v1.0/product/${id}?raw=true`)
      .then(({ data = {} }) => {
        if (data.statusCode === 200) {
          setDetail(data.result);
          data.result.merchantCode === 'EHW' ? setIsErlian(true) : setIsErlian(false);
          // fetchProductLog({ productSku: data.result.productSku });
          if (data.result.status === 'ready') {
            setChecked(true);
          } else if (data.result.status === 'unavailable') {
            setChecked(false);
          }
        }
      })
      .catch((err) => {
        console.error('Product detail fetch error: ', err);
      })
      .finally(() => setDetailLoading(false));
  };

  const activateProduct = (value) => {
    if (value) {
      setToggling(true);
      axios
        .post(`/api/v1.0/product/activate`, {
          productId: detail?._id,
        })
        .then(({ data }) => {
          message.success('Бараа идэвхтэй боллоо.');
          getProductDetail(detail?._id);
        })
        .finally(() => setToggling(false));
      setChecked(true);
    }
  };

  const deactivateProduct = (value) => {
    if (value === false) {
      setToggling(true);
      axios
        .post(`/api/v1.0/product/deactivate`, {
          productId: detail?._id,
        })
        .then(({ data }) => {
          message.success('Бараа идэвхгүй боллоо.');
          getProductDetail(detail?._id);
        })
        .finally(() => setToggling(false));
      setChecked(false);
    }
  };

  const [checked, setChecked] = useState(false);

  const routes = [
    {
      to: {
        pathname: '/merchant/product/list',
        search: location.state?.search,
      },
      breadcrumbName: 'Бараа',
    },
    {
      path: 'first',
      breadcrumbName: 'Нэгж бараа',
    },
  ];

  // const fetchProductLog = async (params) => {
  //   const payload = {
  //     productSku: detail.productSku,
  //     ...params,
  //   };
  //   try {
  //     const { data } = await axios.post(
  //       `/api/v1.0/product/listproductlog`,
  //       payload
  //     );

  //     const { columns, list, limit, page, totalDocs } =
  //       getFormattedResponse(data);
  //     let filteredList = list.filter((item) => item.isShow !== false);
  //     setTableState((prev) => ({
  //       ...prev,
  //       columns: columns,
  //       docs: filteredList,
  //       limit,
  //       page,
  //       totalDocs,
  //     }));
  //   } catch (e) {
  //     console.log("Error>>>", e);
  //   }
  // };

  const getNumberValue = (record) => {
    // if (record?.eventCode === "count") {
    //   return "=";
    // }
    if (parseInt(record.numberValue, 10) > 0) {
      return `+${record.numberValue}`;
    }
    return record.numberValue;
  };

  const exportLogs = async () => {
    const params = {
      pagination: false,
      productSku: detail.productSku,
    };
    setExporting(true);
    try {
      const { data } = await axios.post('/api/v1.0/product/listproductlog', params);
      if (data.statusCode === 200) {
        for (const record of data.result) {
          record.createdAt = record?.createdAt
            ? moment(record?.createdAt).format('YYYY-MM-DD HH:mm')
            : '-';
          record.numberValue = getNumberValue(record);

          record.eventCode = eventCodeDict[record.eventCode] ?? record.eventCode;
        }

        exportToXLSX({
          data: data.result,
          columns: [
            'createdAt',
            'orderCode',
            'fromThirdPartyCode',
            'origin',
            'eventCode',
            'numberValue',
            'totalStock',
            'userRole',
            'userName',
            'note',
          ],
          columnNames: [
            'Огноо',
            'Захиалгын дугаар',
            'Гаднаас үүссэн захиалгын код',
            'Захиалга үүсгэсэн',
            'Захиалгын төрөл',
            'Тоо хэмжээ',
            'Үлдэгдэл',
            'Роль',
            'Өөрчилсөн',
            'Тайлбар',
          ],
          fileName: `Өөрчлөлтийн түүх ${getDateTime(new Date())}`,
        });
      }
    } catch (error) {
    } finally {
      setExporting(false);
    }
  };

  const customizeColumns = (columns = []) => {
    return columns
      .filter((col) => col.key !== 'isShow')
      .map((col) => {
        switch (col.key) {
          case 'createdAt':
            col.render = (_, record) =>
              record?.createdAt ? moment(record?.createdAt).format('YYYY-MM-DD HH:mm') : '-';
            break;
          case 'eventCode':
            col.render = (text) => eventCodeDict[text] ?? text;
            break;
          case 'numberValue':
            col.render = (_, record) => getNumberValue(record);
            break;
          case 'isShow':
            col.render = (text) => {
              if (text === true) {
                return text;
              }
              return null;
            };

            break;
          default:
            break;
        }
        return col;
      });
  };

  /** Идэвхтэй/идэвхгүй болгох (нэг Switch дээр) */
  const onToggleActive = (value) => (value ? activateProduct(value) : deactivateProduct(value));

  const onTabChange = (key) => {
    setCurrentTab(key);
    history.replace({
      pathname: `/merchant/products/${productId}`,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <>
      <PPPageHeader
        title={detail?.title ?? '-'}
        breadcrumb={{
          routes,
        }}
        onBack={() =>
          history.push({
            pathname: '/merchant/product/list',
            search: location.state?.search,
          })
        }
        extra={[
          currentTab === 'general' ? (
            <Link
              to={{
                pathname: '/product/edit',
                state: { product: detail },
              }}
            >
              <Button
                className="edit_button_detail all_buttons"
                size="large"
                icon={<EditOutlined style={{ fontSize: '18px' }} />}
              >
                Засах
              </Button>
            </Link>
          ) : (
            ''
          ),
          currentTab === 'sale' ? (
            detail?.saleItem === null ? (
              <Link
                to={{
                  pathname: '/product/sale/add',
                  state: { product: detail },
                }}
              >
                <Button
                  type="primary"
                  className="add_button_detail all_buttons"
                  icon={<PlusOutlined style={{ fontSize: '16px' }} />}
                >
                  Шинээр хямдрал үүсгэх
                </Button>
              </Link>
            ) : (
              <Link
                to={{
                  pathname: '/product/sale/edit',
                  state: { product: detail },
                }}
              >
                <Button
                  className="edit_button_detail all_buttons"
                  icon={<EditOutlined style={{ fontSize: '18px' }} />}
                >
                  Засах
                </Button>
              </Link>
            )
          ) : (
            ''
          ),
        ]}
      />

      <Tabs
        activeKey={currentTab}
        onChange={onTabChange}
        items={TABS}
        tabBarStyle={{
          marginBottom: 0,
          margin: '0',
          padding: '0 12px',
          backgroundColor: '#fff',
        }}
      />

      <Spin spinning={detailLoading}>
        {currentTab === 'general' && (
          <ProductDetailInfo
            detail={detail}
            isErlian={isErlian}
            checked={checked}
            toggling={toggling}
            onToggleActive={onToggleActive}
          />
        )}

        {currentTab === 'stock' && (
          <Index
            detail={detail}
            onExport={exportLogs}
            exporting={exporting}
            customizeColumns={customizeColumns}
          />
        )}

        {currentTab === 'priceHistory' && isB2B === true && (
          <ProductPrice id={detail} getProductDetail={getProductDetail} />
        )}

        {currentTab === 'sale' && (
          <ProductSale detail={detail.saleItem === null ? [] : [detail.saleItem]} />
        )}
      </Spin>
    </>
  );
};

export default ProductListWithDetail;
